import React, { createRef } from 'react'
import styled from 'styled-components'
import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'
import { SceneChangedEvent, ScrollToSceneEvent } from '../lib/messages'
import { MobileDeviceWidth } from '../lib/constants'
import isMobile from '../lib/is-mobile'
import ScrollHintControl from '../controls/scroll-hint-control'

const Content = styled.div`
  overflow: auto;
  height: 100%;
  @media (max-width: ${MobileDeviceWidth}px) {
    overflow: initial;
    height: 100%;
  }
`
const fold = 450

interface IState {
  hasScrolledOnce: boolean
  finishedMounting: boolean
}

class SmartScroll extends IEventedComponent<{}, IState> {
  state: IState = {
    hasScrolledOnce: false,
    finishedMounting: false
  }
  activeScene: number = -1

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll)
    }
    if (typeof window !== 'undefined') {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
    super.componentWillUnmount()
  }

  onScrollDown = () => {
    if (this.state.finishedMounting && !this.state.hasScrolledOnce)
      this.setState({ hasScrolledOnce: true })
  }

  handleKeyDown = (e: any) => {
    // Don't scroll using keys if the map is focused (as it's used for map navigation then)
    if (
      this.contentRef.current &&
      document.getElementsByClassName('esri-view-surface')[0] !==
        document.activeElement
    ) {
      const scrollPixels = 50
      if (e.key === 'ArrowDown') {
        this.onScrollDown()
        this.getScroller().scrollTo(
          0,
          this.contentRef.current.scrollTop + scrollPixels
        )
      }
      if (e.key === 'ArrowUp') {
        this.getScroller().scrollTo(
          0,
          this.contentRef.current.scrollTop - scrollPixels
        )
      }
    }
  }

  handleScroll = () => {
    this.onScrollDown()
    this.updateActiveScene()
  }

  updateActiveScene = () => {
   
    const elements = document.getElementsByClassName('scene')

    
    for (let i = 0; i < elements.length; i++) {

      const element = elements[i] as HTMLDivElement        
      const sceneIndex = parseInt(element.dataset?.sceneIndex || '-1')

      const bounds = element.getBoundingClientRect()
 
      if (bounds.top <= fold && bounds.top + bounds.height > fold) {

 
    
        if ((this.activeScene !== sceneIndex || this.activeScene === 10) && sceneIndex !== -1) {  
      

          this.publish<SceneChangedEvent>(messageTypes.onSceneChanged, {
            sceneIndex
          })
        
        

        }
        return
      }
    }
  }

  getScroller = (): { scrollTo(x: number, y: number): void } => {
    return isMobile() ? window : this.contentRef?.current || window
  }

  handleScrollToScene = (message: ScrollToSceneEvent) => {
    const element = document.getElementById(
      `scene-${message.sceneIndex}`
    ) as HTMLDivElement
    if (!element) return
    this.onScrollDown()
    this.getScroller().scrollTo(0, element.offsetTop - 156)
  }

  handleScrollToTop = () => {
    this.getScroller().scrollTo(0, 0)
    const element = document.getElementsByClassName(
      'scene'
    )[0] as HTMLDivElement
    const sceneIndex = parseInt(element.dataset?.sceneIndex || '-1')
    if (this.activeScene !== sceneIndex && sceneIndex !== -1) {
      this.publish<SceneChangedEvent>(messageTypes.onSceneChanged, {
        sceneIndex
      })
      this.activeScene = sceneIndex
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && this.contentRef.current) {
      document.addEventListener('keydown', this.handleKeyDown)
    }

    this.subscribe(messageTypes.onScrollToScene, this.handleScrollToScene)
    this.subscribe(messageTypes.onScrollToTop, this.handleScrollToTop)

    // This helps ignore an automatic initial scroll event that is observed on mobile
    window.setTimeout(() => this.setState({ finishedMounting: true }), 200)

    this.updateActiveScene()
    const scene = document.getElementsByClassName('scene')[0] as HTMLDivElement
    if (!scene) return
    const sceneIndex = parseInt(scene.dataset?.sceneIndex || '-1')
    this.publish<SceneChangedEvent>(messageTypes.onSceneChanged, {
      sceneIndex
    })
    this.activeScene = sceneIndex
  }

  contentRef = createRef<HTMLDivElement>()

  render() {
    return (
      <Content
        id="content-scroll-container"
        onScroll={this.handleScroll}
        ref={this.contentRef}
      >
        {this.props.children}
        <ScrollHintControl visible={!this.state.hasScrolledOnce} />
      </Content>
    )
  }
}

export default SmartScroll
